import { graphql } from "../../graphql";

export const MarketUserPermissionsSub = graphql(`
  subscription MarketUserPermissionsSub($folio_user: String!) {
    permission(where: { folio_user: { _eq: $folio_user } }) {
      id
      folio_user
      permission
      package
    }
  }
`);

export const PermissionFolderDetailsQuery = graphql(`
  query PermissionFolderDetailsQuery($folio_user: String!, $packages: [Int!]!) {
    permission(where: { folio_user: { _eq: $folio_user }, package: { _in: $packages } }) {
      package
      packageByPackage {
        name
        package_type
        products(limit: 25, order_by: { name: asc }) {
          id
          name
        }
        products_aggregate {
          aggregate {
            count
          }
        }
      }
    }
  }
`);

export const CurrentUserFragment = graphql(`
  fragment CurrentUserFragment on folio_user {
    __typename
    id
    username
    email
    firstname
    lastname
    roles
    organisation
    subscription_tier
    multisession_check_disabled
    webapp2
    persona
    logout_requested_at
    entitlement {
      level
      code
      expires_at
    }
  }
`);

export const CurrentUserSub = graphql(`
  subscription CurrentUserSub($id: String!) {
    folio_user_by_pk(id: $id) {
      ...CurrentUserFragment
    }
  }
`);

export const CurrentUserQuery = graphql(`
  query CurrentUserQuery($id: String!) {
    folio_user_by_pk(id: $id) {
      ...CurrentUserFragment
    }
  }
`);

export const BlockedUserSub = graphql(`
  subscription BlockedUserSub($id: String!) {
    folio_user_by_pk(id: $id) {
      id
      blocked
    }
  }
`);

export const UserExchangePermissionsSub = graphql(`
  subscription UserExchangePermissionsSub($folio_user: String!) {
    permission(
      where: {
        folio_user: { _eq: $folio_user }
        packageByPackage: { sourceBySource: { source_type: { _eq: exchange } } }
      }
    ) {
      id
    }
  }
`);

export const UserPermissionsDetailedSub = graphql(`
  subscription UserPermissionsDetailedSub($folio_user: String!) {
    permission(where: { folio_user: { _eq: $folio_user } }) {
      id
      folio_user
      permission
      package
      packageByPackage {
        id
        name
        package_type
        sourceBySource {
          id
          name
          source_type
          exchange {
            id
            code
          }
        }
      }
    }
  }
`);

export const UpdateUserPersonaMutation = graphql(`
  mutation UpdateUserPersona($id: String!, $persona: persona_enum) {
    update_folio_user_by_pk(
      pk_columns: { id: $id }
      _set: { persona: $persona }
    ) {
      id
      persona
    }
  }
`);

export const LastExchangeUsageForSingleUser = graphql(`
  subscription LastExchangeUsageForSingleUser($userId: String!) {
    exchange_usage_last(
      where: { folio_user: { _eq: $userId } }
      order_by: { event_date: desc }
    ) {
      source
      event
    }
  }
`);

export const amendExchangeUsage = graphql(`
  mutation AmendExchangeUsage(
    $exchangeUsages: [exchange_usage_insert_input!]!
  ) {
    insert_exchange_usage(objects: $exchangeUsages) {
      affected_rows
    }
  }
`);

export const UserGroupsFragment = graphql(`
  fragment UserGroupsFragment on user_groups {
    id
    display_name
    users
  }
`);

export const UserGroupsQuery = graphql(`
  query UserGroupsQuery {
    user_groups(order_by: { display_name: asc }) {
      ...UserGroupsFragment
    }
  }
`);

export const OrgUserFragment = graphql(`
  fragment OrgUserFragment on folio_user_basic_profile {
    id
    firstname
    lastname
    username
    subscription_tier
    blocked
    # derived from folio_user.roles — the array itself is not exposed here
    is_staff
  }
`);

export const OrgUserProfilesQuery = graphql(`
  query OrgUserProfilesQuery($orgId: Int!) {
    folio_user_basic_profile(
      where: { organisation: { _eq: $orgId } }
      order_by: { username: asc }
    ) {
      ...OrgUserFragment
    }
  }
`);

export const UserProfilesByIdsQuery = graphql(`
  query UserProfilesByIdsQuery($userIds: [String!]!) {
    folio_user_basic_profile(where: { id: { _in: $userIds } }) {
      ...OrgUserFragment
    }
  }
`);

export const PersonaEnumQuery = graphql(`
  query PersonaEnumQuery {
    __type(name: "persona_enum") {
      enumValues {
        name
      }
    }
  }
`);
